import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetDistrictListPagingAndFilterRequest } from '../models/request/district/GetDistrictListPagingAndFilterRequest';

export class DistrictService {
    static async getDistrictListPagingAndFilter(inputObj: GetDistrictListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetDistrictListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/District/GetDistrictListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportDistrictList(inputObj: GetDistrictListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportDistrictList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/District/exportDistrictList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDistrictList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getDistrictList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/District/getDistrictList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteDistrict(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteDistrict', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/District/deleteDistrict', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDistrictById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getDistrictById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/District/getDistrictById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}